import { useMutation } from "@tanstack/react-query";

import { useCrmEnrichmentJobCache } from "../../hooks/useCrmEnrichmentJobCache";
import type { ICrmEnrichmentAPIService } from "../../services/api/types";
import type { CrmEnrichmentJob, CrmEnrichmentJobToggleDTO } from "../../types/types";
import type { ICrmEnrichmentQueryKeyFactory } from "../key-factory/types";

type MutationDependencies = {
    readonly apiService: ICrmEnrichmentAPIService;
    readonly queryKeys: ICrmEnrichmentQueryKeyFactory;
};

export const useCrmEnrichmentJobToggleMutation = ({ apiService, queryKeys }: MutationDependencies) => {
    const { updateExistingJobInCache } = useCrmEnrichmentJobCache(queryKeys);

    return useMutation<CrmEnrichmentJob, unknown, CrmEnrichmentJobToggleDTO>({
        mutationFn: apiService.toggleJob,
        onSuccess(data) {
            updateExistingJobInCache(data);
        },
    });
};
